// extracted by mini-css-extract-plugin
export default {"parkingSpaces":"styles_parkingSpaces__cXN1O","holder":"styles_holder__nUoxY","count":"styles_count__DAGce"};